<template>
  <div>
    <page-title>
      {{ $t("forgotPassword.title") }}
    </page-title>

    <forgot-password />
  </div>
</template>

<script>
import ForgotPassword from '~/marketplace-front-core/components/auth/ForgotPassword'
export default {
  components: { ForgotPassword },
  head () {
    const i18nHead = this.$nuxtI18nHead({ addSeoAttributes: true })
    return {
      title: this.$t('forgotPassword.title'),
      htmlAttrs: {
        ...i18nHead.htmlAttrs
      },
      meta: [
        ...i18nHead.meta,
        { hid: 'robots', name: 'robots', content: 'noindex, nofollow' }
      ],
      link: [
        ...this.metaLink(i18nHead.link)
      ]
    }
  },
  meta: { auth: 'false' }
}
</script>
